import { createAdminWrittenAccountPreviews } from "./AdminWrittenAccountPreviews";

export const AdminWrittenAccountPreviewsClosed = createAdminWrittenAccountPreviews(
	"admin_written_accounts_closed",
	(account) =>
		account.hasBeenActive && (account.status === "closed" || account.status === "declined"),
);
